<template>
    <div class="sa-free-page">
        <div class="sa-free-page-header">
            <b-card class="sa-card sa-card-border" header="Dettagli Piano" header-tag="header" footer-tag="footer" title="">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Nome</label>
                        <span class="sa-data">{{ jsonData.nome }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                        <label class="sa-label-data">Descrizione</label>
                        <span class="sa-data">{{ jsonData.descrizione }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Inizio</label>
                        <span class="sa-data">{{ formatDate(jsonData.dataInizio) }}</span>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data Fine</label>
                        <span class="sa-data">{{ formatDate(jsonData.dataFine) }}</span>
                    </b-col>
                </b-row>
            </b-card>
        </div>
        <div class="sa-free-page-body">
            <b-card class="sa-card sa-card-border" header="Lista Pazienti" header-tag="header" footer-tag="footer" title="">
                <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.listaPazienti" :fields="fieldsPazienti" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                    <template #cell(firstname)="row">
                        <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                    </template>
                    <template #cell(actions)="row">
                        <b-button variant="outline-danger" @click="onDeleteAssociazione(row.item)">
                            <b-icon icon="person-x-fill" aria-hidden="true"></b-icon>
                            Dissocia
                        </b-button>
                    </template>
                </b-table>
            </b-card>
        </div>
        <b-modal ref="mdlAssociazionePaziente" title="Associa Paziente" centered no-close-on-backdrop no-close-on-esc hide-header-close size="xl">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPageAssociazione" :total-rows="rows" :per-page="perPageAssociazione" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
            <div class="b-table-sticky-header">
                <b-table sticky-header :busy="isBusy" ref="table" selectable stacked="lg" striped hover :items="pazientiList" :fields="fieldsPazientiSelected" sort-icon-left head-variant="light" class="sa-b-table" :current-page="1" :per-page="perPageAssociazione" @row-selected="onRowSelected">
                    <template #table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Caricamento...</strong>
                        </div>
                    </template>
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                            <span aria-hidden="true">&check;</span>
                            <span class="sr-only">Selected</span>
                        </template>
                        <template v-else>
                            <span aria-hidden="true">&nbsp;</span>
                            <span class="sr-only">Not selected</span>
                        </template>
                    </template>
                    <template #cell(firstname)="row">
                        <p>{{ row.item.lastname }} {{ row.item.firstname }}</p>
                    </template>
                </b-table>
            </div>
            <template #modal-footer>
                <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
                <b-button variant="outline-success" @click="onClickAssociaPaziente()">Salva</b-button>
            </template>
            <modal-error ref="cmpModalError"></modal-error>
        </b-modal>
    </div>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import ModalError from "../../../template/components/modal/components/ModalError.vue";

export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            id: null,
            isBusy: false,
            strutturaOptions: [],
            pathResource: "/pazientiprogetti",
            pathResourceStrutture: "/strutture",
            pathResourceAssociaPaziente: "/pazientiprogettianagrafica",
            pathResourcePazienti: "/pazienti",
            currentPageAssociazione: 1,
            currentPage: 1,
            rows: 0,
            perPage: 10000000,
            perPageAssociazione: 15,
            jsonData: { id: null, codiceStruttura: null, idPresidio: null, nome: null, note: null },
            showModalLoading: false,
            pazientiList: [],
            selected: [],
            idPiano: null,
            keyPiano: 100,
            jsonAssociaPaziente: {},
            fieldsPazienti: [
                {
                    label: "Identificativo",
                    key: "identificativo",
                    sortable: true,
                    thStyle: "width: 12rem",
                },
                {
                    label: "Cognome",
                    key: "cognome",
                    sortable: true,
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 15rem",
                },

                {
                    label: "",
                    key: "actions",
                    tdClass: "text-right",
                },
            ],
            fieldsPazientiSelected: [
                {
                    label: "",
                    key: "selected",
                    thStyle: "width: 2.5rem",
                    tdClass: "text-center",
                },
                {
                    label: "Identificativo",
                    key: "identificativo",
                    sortable: true,
                    thStyle: "width: 12rem",
                },

                {
                    label: "Cognome",
                    key: "cognome",
                    sortable: true,
                },
                {
                    label: "Nome",
                    key: "nome",
                    sortable: true,
                    thStyle: "width: 15rem",
                },
            ],
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
        currentPageAssociazione() {
            let me = this;
            me.loadDataPazienti();
        },
    },
    mounted: function () {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
        // me.loadDataPazienti();
    },
    methods: {
        loadDataStruttureSuccess(response) {
            let me = this;
            me.strutturaOptions = response.data.data;
            me.strutturaOptions.unshift({ codiceStruttura: null, denominazione: this.$i18n.t("clinic.lblSelectStructure") });
            me.loadData();
            me.$emit("afterLoadData");
        },
        loadDataStruttureError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento delle strutture", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },
        loadData() {
            let me = this;
            me.show;
            if (me.id === "-1") {
                me.$emit("afterLoadData");
            } else {
                me.loadDataResources(me.pathResource + "/" + me.id, null, me.loadDataSuccess, me.loadDataError);
                me.$emit("beforeLoadData");
            }
        },
        loadDataSuccess(response) {
            let me = this;
            me.$emit("afterLoadData");
            me.jsonData = response.data.data;
            me.idPiano = me.jsonData.id;
            me.keyPiano++;
        },
        loadDataError(response) {
            let me = this;
            me.$bvToast.toast("Errore durante il caricamento dei dati", response, {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
            me.$emit("afterLoadData");
        },

        // onClickPianoEdit() {
        //     let me = this;
        //     me.loadDataPazienti();
        // },
        loadDataPazienti() {
            let me = this;
            let filtro = { page: me.currentPageAssociazione, forPage: me.perPageAssociazione };
            UtilityMixin.methods.loadDataResources(me.pathResourcePazienti, filtro, me.onloadDataPazientiSuccess, me.onloadDataPazientiError);
        },
        onloadDataPazientiSuccess(response) {
            let me = this;
            me.rows = response.data.data.recordsNumber;
            me.pazientiList = response.data.data.list;
        },
        onloadDataPazientiError(error) {
            console.log(error);
        },
        saveSucessResponse() {
            let me = this;
            me.loadData();
        },
        saveErrorResponse(response) {
            if (response.response.status === 400) {
                this.$emit("errorRestCall", response);
            } else {
                this.$bvToast.toast("Errore nel salvarei dati del Piano: " + response.message, {
                    title: "",
                    variant: "danger",
                    solid: true,
                });
            }
        },
        associaPaziente() {
            let me = this;
            me.loadDataPazienti();
            me.jsonAssociaPaziente = { idAnagrafica: null, idProgetto: me.id };
            me.$refs.mdlAssociazionePaziente.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonAssociaPaziente = { idAnagrafica: null, idProgetto: me.id };
            me.$refs.mdlAssociazionePaziente.hide();
        },
        onClickAssociaPaziente() {
            let me = this;
            for (let i = 0; i < me.selected.length; i++) {
                me.jsonAssociaPaziente.idAnagrafica = me.selected[i].id;
                UtilityMixin.methods.saveResource(me.pathResourceAssociaPaziente, me.jsonAssociaPaziente, me.saveAssociaPazienteSuccess, me.saveAssociaPazienteError);
            }
        },
        saveAssociaPazienteSuccess() {
            let me = this;
            me.loadData();
            me.$refs.mdlAssociazionePaziente.hide();
            me.$bvToast.toast("Salvataggio avvvenuto con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
        },
        saveAssociaPazienteError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        onRowSelected(items) {
            this.selected = items;
        },
    },
};
</script>

<style></style>
